import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filtersDropdown", "addButton"]

  addFilter(event) {
    const selector = event.params.selector
    if (! selector) return

    const element = this.element.querySelector(selector)
    if (! element) return

    this.#moveFilterToBack(element)
    element.classList.remove("d-none")
    this.#clickFilterButton(element)
    event.target.closest("li[data-filters--add-filter-target='addButton']")?.remove()
  }

  addButtonTargetDisconnected() {
    if (this.addButtonTargets.length === 0) {
      this.dropdownTarget.classList.add("d-none")
    }
  }

  // Move element after the last .h-filter sibling
  #moveFilterToBack(element) {
    const container = element.parentElement
    if (! container) return

    const filters = container.querySelectorAll(".h-filter")

    if (filters.length > 0) {
      const lastFilter = filters[filters.length - 1]

      if (lastFilter !== element) {
        if (lastFilter.nextSibling) {
          container.insertBefore(element, lastFilter.nextSibling)
        } else {
          container.appendChild(element)
        }
      }
    } else {
      container.appendChild(element)
    }
  }

  #clickFilterButton(element) {
    const filterButton = element.querySelector(".h-filter__button")
    if (! filterButton) return

    // Wait for the next animation frame to ensure that the filter button is clickable
    const raf = window.requestAnimationFrame || function(cb) { return setTimeout(cb, 16) }
    raf(function() {
      filterButton.dispatchEvent(new MouseEvent("click", { bubbles: true }))
    })
  }
}
